import React from 'react';
import { FormattedMessage } from 'react-intl';
import type { AssetType as AssetTypeEnum, FuelType as FuelTypeEnum } from './types';

import Rioglyph from '@rio-cloud/rio-uikit/src/Rioglyph';
import { getFuelIcon } from '@rio-cloud/rio-uikit/src/fuelTypeUtils';
import type { FuelType } from '@rio-cloud/rio-uikit/lib/es/src/utils/fuelTypeUtils';
import type { IconType } from '@rio-cloud/rio-uikit/src/components/rioglyph/Rioglyph';
import SimpleTooltip from '@rio-cloud/rio-uikit/SimpleTooltip';

interface AssetTypeProps {
    assetType: AssetTypeEnum;
    fuelType?: FuelTypeEnum | null;
}

const AssetType = React.memo((props: AssetTypeProps) => {
    const fuelTypeIcon = props.fuelType ? getFuelIcon(props.fuelType.toLowerCase() as FuelType) : undefined;

    return (
        <span className='display-flex'>
            <SimpleTooltip
                placement='right'
                content={
                    <>
                        <FormattedMessage id='assets.assets.asset.type' />
                        <span>: </span>
                        <FormattedMessage id={`assets.assets.asset.type.${props.assetType.toLowerCase()}`} />
                        {props.fuelType && (
                            <>
                                <br />
                                <FormattedMessage id='assets.masterdata.fuel-type' />
                                <span>: </span>
                                <FormattedMessage id={`assets.masterdata.fuel-type.${props.fuelType.toLowerCase()}`} />
                            </>
                        )}
                    </>
                }
            >
                <span>
                    <Rioglyph
                        size='h3'
                        icon={`rioglyph-${props.assetType.toLowerCase()}` as IconType}
                        pairIcon={fuelTypeIcon}
                    />
                </span>
            </SimpleTooltip>
            <span hidden>
                <FormattedMessage id={`assets.assets.asset.type.${props.assetType.toLowerCase()}`} />
            </span>
        </span>
    );
});

export default AssetType;
